// extracted by mini-css-extract-plugin
export default {"status":"WebhookDetails_status__BdhgJ","green":"WebhookDetails_green__aXZBL"};